import { mapWrapper } from '@pages/map/map';
import OlSelect from 'ol/interaction/Select';
import * as olEventsCondition from 'ol/events/condition';
import { unByKey } from 'ol/Observable';
import * as olStyle from 'ol/style';
import { setMapCursor } from '@openlayers/ol-utils';
import { LayerWrapper } from '@openlayers/LayerWrapper';

export class ClickSelection<T> {
    private mouseHoverHandler: any;
    private readonly selectClickInteraction: OlSelect;

    constructor(private layerWrapper: LayerWrapper<any>, private onSelect: (items: T[]) => void, private selectedStyle: olStyle.Style) {
        this.selectClickInteraction = new OlSelect({
            condition: olEventsCondition.click,
            toggleCondition: olEventsCondition.click,
            layers: [layerWrapper.layer],
            style: feature => {
                if (typeof layerWrapper.styleFunction === 'function') {
                    if (selectedStyle) {
                        return [this.selectedStyle, ...layerWrapper.styleFunction(feature)];
                    } else {
                        return layerWrapper.styleFunction(feature); // apply same feature style here, draw selection marker someplace else
                    }
                }
            },
        });

        this.selectClickInteraction.on('select', e => {
            const itemsData = [];
            this.selectClickInteraction.getFeatures().forEach(selected => {
                let features;
                if (Array.isArray(selected.get('features'))) {
                    features = selected.get('features');
                } else {
                    features = [selected];
                }
                features
                    .map(f => f.get('data'))
                    .filter(Boolean)
                    .forEach(data => itemsData.push(data));
            });
            this.onSelect(itemsData);
        });
    }

    activate() {
        const mapInstance = mapWrapper.getInstance();
        mapInstance.addInteraction(this.selectClickInteraction);
        this.mouseHoverHandler = mapWrapper.events.onMouseMove(evt => {
            const pixel = mapInstance.getEventPixel(evt.originalEvent);
            const feature = mapInstance.forEachFeatureAtPixel(pixel, f => f);
            setMapCursor(mapInstance, feature && (feature.get('type') == 'logpoint' || feature.get('type') == 'image') ? 'pointer' : '');
        });
    }

    deactivate() {
        this.clear();
        mapWrapper.getInstance().removeInteraction(this.selectClickInteraction);
        unByKey(this.mouseHoverHandler);
    }

    // for manually (pre)selecting from code
    select(items: T[]) {
        const selectionCollection = this.selectClickInteraction.getFeatures();

        items.forEach((l: any) => {
            selectionCollection.push(this.layerWrapper.getFeatureById(l.id));
        });
    }

    clear() {
        this.selectClickInteraction.getFeatures().clear();
    }
}
